import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../services/instance";
import { endpoints } from "../../constants/endpoints";

export const ProfessionalServicesAPI = createAsyncThunk(
    "ProfessionalServicesAPI",
    async (data, { rejectWithValue }) => {
        try {
            const response = await api.post(endpoints.professionalAddServices(), data)
            return response
        } catch (error) {
            if (error.response && error.response.data) {
                return rejectWithValue(error.response.data);
            }
            return rejectWithValue({ message: 'Something went wrong' });
        }
    }
)

export const ProfessionalServicesShowAPI = createAsyncThunk(
    "ProfessionalServicesShowAPI",
    async (id, { rejectWithValue }) => {
        try {
            const response = await api.get(endpoints.professionalAddServicesShow(id))
            return response
        } catch (error) {
            if (error.response && error.response.data) {
                return rejectWithValue(error.response.data);
            }
            return rejectWithValue({ message: 'Something went wrong' });
        }
    }
)

export const ProfessionalServiceUpdateAPI = createAsyncThunk(
    "ProfessionalServiceUpdateAPI",
    async (data, { rejectWithValue }) => {
        try {
            const id = data?.id;
            const response = await api.put(endpoints.professionalAddServiceUpdate(id), data)
            return response
        } catch (error) {
            if (error.response && error.response.data) {
                return rejectWithValue(error.response.data);
            }
            return rejectWithValue({ message: 'Something went wrong' });
        }
    }
)

export const professionalDeleteService = createAsyncThunk(
    "professionalDeleteService",
    async (id, { rejectWithValue }) => {
        try {
            const response = await api.delete(endpoints.professionalDeleteService(id))
            return response
        } catch (error) {
            if (error.response && error.response.data) {
                return rejectWithValue(error.response.data);
            }
            return rejectWithValue({ message: 'Something went wrong' });
        }
    }
)

const initialState = {
    loading: false,
    showLoading: false,
    deleteLoading: false,
    services: []
}

const ProfessionalAddServicesSlice = createSlice({
    initialState,
    name: "ProfessionalAddServicesSlice",
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(ProfessionalServicesAPI.pending, (state, action) => {
            state.loading = true;
        })

        builder.addCase(ProfessionalServicesAPI.fulfilled, (state, action) => {
            state.loading = false
        })

        builder.addCase(ProfessionalServicesAPI.rejected, (state, action) => {
            state.loading = false
        })


        // FETCH DATA
        builder.addCase(ProfessionalServicesShowAPI.pending, (state, action) => {
            state.showLoading = true
        })

        builder.addCase(ProfessionalServicesShowAPI.fulfilled, (state, action) => {
            state.showLoading = false;
            state.services = action?.payload?.data?.data || [];
        })

        builder.addCase(ProfessionalServicesShowAPI.rejected, (state, action) => {
            state.showLoading = false
        })

        // UPDATE API
        builder.addCase(ProfessionalServiceUpdateAPI.pending, (state, action) => {
            state.loading = true
        })

        builder.addCase(ProfessionalServiceUpdateAPI.fulfilled, (state, action) => {
            state.loading = false;

        })

        builder.addCase(ProfessionalServiceUpdateAPI.rejected, (state, action) => {
            state.loading = false
        })

        // DELETE API
        builder.addCase(professionalDeleteService.pending, (state, action) => {
            state.deleteLoading = true
        })

        builder.addCase(professionalDeleteService.fulfilled, (state, action) => {
            state.deleteLoading = false;

        })

        builder.addCase(professionalDeleteService.rejected, (state, action) => {
            state.deleteLoading = false
        })
    },
})

export const { } = ProfessionalAddServicesSlice.actions
export default ProfessionalAddServicesSlice.reducer